export default {
  computed: {
      entities() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      if(this.$store.getters.getAllEntities && this.$store.getters.getAllEntities.length && this.$store.getters.getAllEntities.length>0){
        return this.$store.getters.getAllEntities.sort(compare);
      }else {
        
      return this.$store.getters.getAllEntities
      }
    },
    entitiesPattern() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      if(this.$store.getters.getAllEntities && this.$store.getters.getAllEntities.length && this.$store.getters.getAllEntities.length>0){
        return this.$store.getters.getAllEntities.sort(compare);
      }else {
        
      return this.$store.getters.getAllEntities
      }
    },
    entity() {
      return this.$store.getters.getEntity;
    },
    allEntities() {
      return this.$store.getters.getAllEntities
    },
    filterBySearchEntities() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return this.entities
        .filter(el => {
          return el.name.toLowerCase().includes(this.search.toLowerCase());
        })
        .sort(compare);
    }
  }
}




// WEBPACK FOOTER //
// ./src/mixins/mixin.entities.js